import React from 'react';
import { Row, Col, Card, CardHeader, CardBody } from 'reactstrap';
import { HorizontalBar } from 'react-chartjs-2';

export function HorizontalBarChart({ title, data }) {
  if (!data) {
    return null;
  }

  const { labels, data: chartData, colors } = data;

  const formattedData = {
    labels: labels,
    datasets: [
      {
        data: chartData,
        backgroundColor: colors
      }
    ]
  };

  const options = {
    indexAxis: 'y',
    maintainAspectRatio: true,
    scales: {
      x: {
        beginAtZero: true,
        ticks: {
          stepSize: 5
        }
      }
    },
    responsive: true,
    plugins: {
      zoom: {
        pan: {
          enabled: true,
          mode: 'y'
        },
        zoom: {
          enabled: true,
          mode: 'y'
        }
      }
    }
  };

  return (
    <Card>
      <CardHeader>
        <h5 className="h3 mb-0">{title}</h5>
      </CardHeader>
      <CardBody>
        <Row>
          <Col style={{ alignSelf: 'center', width: '100%' }}>
            <div
              className="chart"
              style={{ maxHeight: '400px', overflowY: 'auto', width: '100%' }}
            >
              <HorizontalBar data={formattedData} options={options} />
            </div>
          </Col>
        </Row>
      </CardBody>
    </Card>
  );
}
